
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#27AE60"}}),_c('g',{attrs:{"clip-path":"url(#clip0_7625_15216)","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11.25 13.333h2.917M24.583 20a3.333 3.333 0 100-6.667h-6.25m-2.916 13.334a3.333 3.333 0 110-6.667h5m-.834 6.667h5"}}),_c('path',{attrs:{"d":"M16.25 15.417a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167zM17.5 28.75a2.083 2.083 0 100-4.167 2.083 2.083 0 000 4.167zM22.5 22.083a2.083 2.083 0 100-4.166 2.083 2.083 0 000 4.166zM24.695 28.503c.034.206.232.303.424.223.34-.14.947-.415 1.866-.912.616-.332 1.021-.598 1.286-.797.33-.25.33-.655 0-.904-.265-.2-.67-.466-1.286-.799-.919-.495-1.525-.77-1.866-.911-.192-.08-.39.017-.424.223-.053.323-.112.912-.112 1.938 0 1.027.06 1.616.112 1.94z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_7625_15216"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(10 10)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    